import { IHttpService, IPromise } from "angular";
import HttpService from "../common/services/http.service";
import { FamilyPlanStartResult, FamilyPlanInfoDto, FamilyPlanMasterInfoDto, FamilyPlanMenuItems } from "./family-plan.model";
import { FamilyPlanTypes } from "../common/services/package/package.model";

/* @ngInject */
export default class FamilyPlanService {

    constructor(
        private $http: IHttpService,
        private httpService: HttpService
    ) {
    }

    public userHasFamilyPackage(): IPromise<FamilyPlanMenuItems> {
    return this.httpService.extractResponseResult(
            this.$http.get(`hafifmuzik/mobile/family-plan/family-menu-items`, null)
        )
        .then(response => response);
    }

    public getFamilyPlanInfo(type): IPromise<FamilyPlanInfoDto> {
        return this.httpService.extractResponseResult(
                this.$http.get(`hafifmuzik/mobile/family-plan/info?type=${type}`, null)
            )
            .then(response => response);
    }

    public addressAutoComplete(addressinputval): IPromise<any> {
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/location/query`, {"key": addressinputval })
        );
    }

    public addressUpdate(addressinputval): IPromise<any> {
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/update-address`, {"address": addressinputval })
        );
    }

    public approveUpdate(addressinputval): IPromise<any> {
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/approve-address`, {"address": addressinputval })
        );
    }

    public saveFamilyInfo(strBirthDate, emailVal, address, type): IPromise<FamilyPlanStartResult>{
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/start/v2`, {"strBirthDate" : strBirthDate, "email": emailVal,"address": address, "type": type})
        );
    }

    public joinFamilyPlan(strBirthDate, emailVal, address, token, type): IPromise<string>{
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/join/v2`, {"strBirthDate" : strBirthDate, "email": emailVal,"address": address, "token": token, "type": type})
        );
    }

    
    public cancelBySubMember(type): IPromise<string>{
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/cancel-by-submember?type=${type}`, null)
        );
    }

    public kickSubMember(subId, type): IPromise<string>{
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/kick-submember`, {"subMemberId": subId, "type": type })
        );
    }

    public generateInvitationUrl(type): IPromise<string>{
        return this.httpService.extractResponseResult(
            this.$http.get(`hafifmuzik/mobile/family-plan/generate-invitation-url?type=${type}`, null)
        );
    }

    public getMasterInfoByToken(token): IPromise<FamilyPlanMasterInfoDto>{
        return this.httpService.extractResponseResult(
            this.$http.get(`hafifmuzik/mobile/family-plan/master/info?token=${token}`, null)
        );
    }

    public sendEmail(email: string, type?: FamilyPlanTypes): IPromise<any> {
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/sendEmail`, null, {
                params: { email, type }
            })
        );
    }

    public validateEmail(email: string, emailCode: string, type?: FamilyPlanTypes): IPromise<any> {
        return this.httpService.extractResponseResult(
            this.$http.post(`hafifmuzik/mobile/family-plan/validateEmail`, null, {
                params: { email, emailCode, type }
            })
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/family-plan/famil-plan.service.ts